// src/features/inventory/services/msds.js
import { apiClient } from '../../../services/api/client';

export const msdsAPI = {
  getMSDS: (itemId) =>
    apiClient.get(`/api/v1/inventory/msds/${itemId}`),

  getMSDSHistory: (itemId) =>
    apiClient.get(`/api/v1/inventory/msds/${itemId}/history`),

  createMSDS: (itemId, body) =>
    apiClient.post(`/api/v1/inventory/msds/${itemId}`, body),

  updateMSDS: (itemId, body) =>
    apiClient.put(`/api/v1/inventory/msds/${itemId}`, body),

  deleteMSDS: (itemId) =>
    apiClient.delete(`/api/v1/inventory/msds/${itemId}`),

  listAllMSDS: (params = {}) => {
    const query = new URLSearchParams();
    if (params.search) query.set('search', params.search);
    if (params.status) query.set('status', params.status);
    if (params.language) query.set('language', params.language);
    if (params.hazard_level) query.set('hazard_level', params.hazard_level);
    const qs = query.toString();
    return apiClient.get(`/api/v1/inventory/msds/${qs ? '?' + qs : ''}`);
  },
};
